import Dialog from "./Dialog";

const ConfirmDialog = ({ msg, isOpenConfirm, handleClose, handleSubmit }) => {
  return (
    <Dialog isOpen={isOpenConfirm} onClose={handleClose}>
      <div>
        <p>{msg}</p>
        <p>Are you sure?</p>
        <button
          className="button"
          style={{ padding: 10, marginRight: "50px" }}
          onClick={handleSubmit}
        >
          OK
        </button>
        <button
          className="button"
          style={{ padding: 10 }}
          onClick={() => handleClose()}
        >
          Cancel
        </button>
      </div>
    </Dialog>
  );
};

export default ConfirmDialog;
